<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M4,9C4,9,8,9,8,9C8.55,9,9,8.55,9,8C9,7.45,8.55,7,8,7C8,7,4,7,4,7C3.45,7,3,7.45,3,8C3,8.55,3.45,9,4,9C4,9,4,9,4,9ZM15,0C15,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,15,0,15C0,15.55,0.45,16,1,16C1,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0ZM10,14C10,14,2,14,2,14C2,14,2,2,2,2C2,2,10,2,10,2C10,2,10,14,10,14C10,14,10,14,10,14ZM14,14C14,14,11,14,11,14C11,14,11,2,11,2C11,2,14,2,14,2C14,2,14,14,14,14C14,14,14,14,14,14Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'RemoveColumnLeft',
} as DefineComponent
</script>
